import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, Location, PlatformLocation } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
declare const HelloSign: any;
import { DriverQualificationService } from '../service/driver-qualification.service';
import { catchError, first, map, switchMap, tap } from 'rxjs/operators';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { Store } from '@ngxs/store';
import { RegistrationState, NotificationStateModel } from 'src/app/registration/state/registration.state';
import { ROUTE_DQF, ROUTE_DQF_DOCUMENT_UPLOAD, ROUTE_DQF_SIGN_DECLARATION, ROUTE_GET_DRIVER_SIGN, ROUTER_DQF_VIEW } from 'src/app/shared/routes';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { DQF_DOC_STATUS } from '../constants';
import { DqfDocument } from '../models/dqfDocument';
import dayjs from 'dayjs';
import { DRIVER_DOC_CONTEXT_INITIAL_DQF } from '../constants';
import { forkJoin, of } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DqfDriverSignatureComponent } from '../dqf-driver-signature/dqf-driver-signature.component';

const ACTOR_TYPE_DRIVER = 'driver';
const DOCUMENT_SIGN_DISPLAY_NAME = 'Declaration';
const DOCUMENT_TYPE_SIGN = 'declarationForm';
const UPLOADED_STATUS = 'uploaded';
const PENDING_STATUS = 'Pending';
const SIGNED_STATUS = 'signed';
const REJECTED_STATUS = 'Rejected';
const DELETE_MESSAGE = 'Are you sure you want to delete this document? This action cannot be undone.';
const DELETED_DOCUMENT = 'Document deleted successfully';
const UPLOADED_DOCUMENT = 'Uploading your document...';
const COLLECTED_DOCUMENT = 'Collecting your document...';
const DISABLE_TOP_LOADING_BAR = true;
const EMPLOYMENT_HISTORY_CHECK = 'EmploymentHistoryCheck';
const EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME = 'Employment History Check';
const EMPLOYMENT_HISTORY_CHECK_DECLARATION_NOT_SIGNED = 'EMPLOYMENT HISTORY CHECK NOT SIGNED';
const EMPLOYMENT_HISTORY_CHECK_DECLARATION_SIGNED = 'EMPLOYMENT HISTORY CHECK CONSENT FORM SIGNED';
const DEFAULT_DECLARATION_NOT_SIGNED = 'DECLARATION IS NOT SIGNED';
const DEFAULT_DECLARATION_SIGNED = 'DECLARATION FORM SIGNED';
const LOADING_RESOURCES = 'Loading signing resources. The page will open shortly...';
const ERROR_LOADING_RESOURCES = 'Error loading signing resources, please try again later';

@Component({
  selector: 'app-dqf-sign-declaration',
  templateUrl: './dqf-sign-declaration.component.html',
  styleUrls: ['./dqf-sign-declaration.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class DqfSignDeclarationComponent implements OnInit, OnDestroy {
  isContentReady: boolean = false;
  documentData: any;
  buttonText: string;
  generationDate: string = '';
  isDocumentProcessing: boolean = false;
  isRejected: boolean = false;
  isSigning: boolean = true;
  dqfId: string;
  dqfData;
  declarationFormDqfData;
  declarationFormDriverData;
  declarationLabel: string = DEFAULT_DECLARATION_NOT_SIGNED;
  isEmploymentHistoryCheck = false;
  pageTitle = DOCUMENT_SIGN_DISPLAY_NAME;
  isSigningReady: boolean = false;
  hellosignClient: any = null;
  signingUrl: string | null = null;
  documentId: string | null = null;
  isSignRequested: boolean = false;
  removeUrlFromCache = false;
  zohoSigningUrl: SafeResourceUrl | null = null;
  showIframe = false;
  locationSubscription: any;
  driverDetails: any;
  uploadUrl: any;
  dontShowViewButton: boolean;

  constructor(
    private readonly location: Location,
    private router: Router,
    private driverQualificationService: DriverQualificationService,
    private readonly registrationService: RegistrationService,
    private readonly toastService: ToastService,
    @Inject('environmentData') private environment: any,
    private readonly store: Store,
    private route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    private readonly platformLocation: PlatformLocation,
    private readonly dialog: MatDialog
  ) {
    this.route?.queryParams?.subscribe(params => {
      const declarationType = params['type'];
      if (declarationType && declarationType === EMPLOYMENT_HISTORY_CHECK) {
        this.declarationLabel = EMPLOYMENT_HISTORY_CHECK_DECLARATION_NOT_SIGNED;
        this.pageTitle = EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME;
        this.isEmploymentHistoryCheck = true;
      }
    });
  }

  ngOnInit(): void {
    of(null)
      .pipe(
        switchMap(() => {
          this.getDqfData();
          this.getDeclarationFormData();
          this.loadDocuments();
          return of(true);
        })
      )
      .subscribe(() => {
        this.isContentReady = true;
      });
    window.addEventListener('message', this.handleRoutingFromZoho);
    this.platformLocation.onPopState(() => {
      this.resetZohoSignState();
    });
    this.driverDetails = this.registrationService.getDriver();
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleRoutingFromZoho);
  }

  loadHelloSignData(): void {
    const declarationModel = {
      actorType: ACTOR_TYPE_DRIVER,
      documentDisplayName: '',
      documentType: '',
      context: DRIVER_DOC_CONTEXT_INITIAL_DQF,
      dqfId: this.dqfId,
      // Uncomment this when we want to use canvas signature
      canvasSignature: false
    };

    if (this.isEmploymentHistoryCheck) {
      declarationModel.documentDisplayName = EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME;
      declarationModel.documentType = EMPLOYMENT_HISTORY_CHECK;
      // Uncomment this when we want to use canvas signature
      declarationModel.canvasSignature = true;
    } else if (!this.environment.featureFlags?.enableZohoSign) {
      declarationModel.documentDisplayName = DOCUMENT_SIGN_DISPLAY_NAME;
      declarationModel.documentType = DOCUMENT_TYPE_SIGN;
      // Uncomment this when we want to use canvas signature
      delete declarationModel.canvasSignature;
    }

    // const helloSignResponse = this.driverQualificationService.getAndConsumeHelloSignUrl(declarationModel.documentType);
    //  Uncomment this when we want to use canvas signature
    const helloSignResponse = null;

    if (helloSignResponse) {
      this.signingUrl = helloSignResponse.signatureUrl;
      this.documentId = helloSignResponse.documentId;
      this.uploadUrl = helloSignResponse.uploadURL;
      this.isSigningReady = true;

      if (this.isSignRequested) {
        this.openHelloSignDialog();
      }
    } else {
      this.driverQualificationService
        .getHelloSignUrl(declarationModel)
        .pipe(
          tap((response: any) => {
            if (response) {
              this.signingUrl = response.signatureUrl;
              this.documentId = response.documentId;
              this.uploadUrl = response.uploadURL;
              this.isSigningReady = true;
              this.removeUrlFromCache = true;

              if (this.isSignRequested) {
                this.removeUrlFromCache = false;
                this.driverQualificationService.getAndConsumeHelloSignUrl(declarationModel.documentType);
                this.openHelloSignDialog();
              }
            }
          }),
          catchError(error => {
            this.isSigningReady = false;
            this.toastService.showError(ERROR_LOADING_RESOURCES);
            return error;
          })
        )
        .subscribe();
    }
  }

  getDqfData(): void {
    if (!this.driverQualificationService.dqfId || this.dqfId) {
      this.router.navigate([`${ROUTE_DQF}`]);
      return;
    }
    this.dqfId = this.driverQualificationService.dqfId;
    if (!this.driverQualificationService.dqfData) {
      this.driverQualificationService.getDqfById(this.dqfId).subscribe((response: DqfDocument) => {
        if (response) {
          this.dqfData = response;
        }
      });
    }
    this.dqfData = this.driverQualificationService.dqfData;
  }

  getDeclarationFormData(): void {
    if (this.dqfData) {
      let filterType = DOCUMENT_TYPE_SIGN;
      if (this.isEmploymentHistoryCheck) {
        filterType = EMPLOYMENT_HISTORY_CHECK;
      }
      this.declarationFormDqfData = this.dqfData.attachedDocuments.filter(e => e.type === filterType);
      this.determineSignatureStatus();
    }
  }
  backAction(): void {
    this.location.back();
  }

  buttonAction(): void {
    if (this.isSigning) {
      this.isSignRequested = true;
      if (this.isSigningReady && this.isEmploymentHistoryCheck) {
        //  this.removeUrlFromCacheIfRequired();
        //  this.openHelloSignDialog();
        // Uncomment this when we want to use canvas signature
        // this.openDriverSignatureDialog();
        this.getSignatureUplaodUrl();
      } else if (!this.isEmploymentHistoryCheck && this.environment.featureFlags?.enableZohoSign) {
        this.zohoSigningUrl = '';
        this.loadZohoSignData();
      } else {
        this.toastService.showInfo(LOADING_RESOURCES);
      }
    } else {
      this.viewDocument();
    }
  }
  getSignatureUplaodUrl(): void {
    const declarationModel = {
      actorType: ACTOR_TYPE_DRIVER,
      documentDisplayName: EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME,
      documentType: EMPLOYMENT_HISTORY_CHECK,
      context: DRIVER_DOC_CONTEXT_INITIAL_DQF,
      dqfId: this.dqfId,
      canvasSignature: true
    };
    this.driverQualificationService
      .getHelloSignUrl(declarationModel)
      .pipe(
        tap((response: any) => {
          if (response) {
            this.signingUrl = response.signatureUrl;
            this.documentId = response.documentId;
            this.uploadUrl = response.uploadURL;
            this.isSigningReady = true;
            //  this.removeUrlFromCache = true;

            if (this.isSignRequested) {
              //this.removeUrlFromCache = false;
              // this.driverQualificationService.getAndConsumeHelloSignUrl(declarationModel.documentType);
              this.openDriverSignatureDialog();
            }
          }
        }),
        catchError(error => {
          this.isSigningReady = false;
          this.toastService.showError(ERROR_LOADING_RESOURCES);
          return error;
        })
      )
      .subscribe();
  }
  openDriverSignatureDialog(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_GET_DRIVER_SIGN}`], {
      state: {
        dqfData: this.dqfData,
        driverDetails: this.driverDetails,
        uploadUrl: this.uploadUrl
      }
    });
  }
  viewDocument(): void {
    this.router.navigateByUrl(`${ROUTER_DQF_VIEW}/${this.declarationFormDriverData.id}`);
  }
  removeUrlFromCacheIfRequired() {
    if (this.removeUrlFromCache) {
      let documentType = DOCUMENT_TYPE_SIGN;
      this.removeUrlFromCache = false;

      if (this.isEmploymentHistoryCheck) {
        documentType = EMPLOYMENT_HISTORY_CHECK;
      }
      this.driverQualificationService.getAndConsumeHelloSignUrl(documentType);
    }
  }

  openHelloSignDialog(): void {
    if (!this.isSigningReady) {
      this.isContentReady = false;
      return;
    }

    this.isContentReady = false;

    // If Zoho Sign is enabled, use that instead
    if (this.environment.featureFlags?.enableZohoSign) {
      this.openZohoSignDialog();
      return;
    }

    try {
      // Check if HelloSign is available globally
      if (typeof window !== 'undefined' && (window as any).HelloSign) {
        this.hellosignClient = new (window as any).HelloSign({
          clientId: this.environment.helloSignClientId,
          testMode: !this.environment?.featureFlags?.production
        });
      } else if (typeof HelloSign !== 'undefined' && typeof HelloSign === 'function') {
        this.hellosignClient = new HelloSign({
          clientId: this.environment.helloSignClientId,
          testMode: !this.environment?.featureFlags?.production
        });
      } else {
        this.openZohoSignDialog();
        return;
      }
    } catch (error) {
      console.error('Error initializing HelloSign:', error);
      this.openZohoSignDialog();
      return;
    }

    if (this.signingUrl) {
      this.hellosignClient.open(this.signingUrl, () => { });

      let status = '';
      this.hellosignClient.on('finish', () => {
        status = 'finished';
      });
      this.hellosignClient.on('cancel', () => {
        status = 'canceled';
      });
      this.hellosignClient.on('close', () => {
        if (status === 'finished') {
          this.updateDocumentStatus(this.documentId, SIGNED_STATUS);
        }
        if (status === 'canceled') {
          this.isContentReady = true;
          this.isSigning = true;
          this.isSignRequested = false;
          this.signingUrl = null;
          this.documentId = null;
          this.loadHelloSignData();
          this.defaultDateAndButtonText();
        }
      });
    }
  }
  setDocumentStatusDriverReviewed(): void {
    const docModel = {
      attachedDocument: {
        type: DOCUMENT_TYPE_SIGN,
        status: DQF_DOC_STATUS.DRIVER_REVIEWED
      }
    };

    if (this.isEmploymentHistoryCheck) {
      docModel.attachedDocument.type = EMPLOYMENT_HISTORY_CHECK;
    }

    this.driverQualificationService.updateDqfStatus(this.dqfId, docModel).subscribe(() => {
      this.isContentReady = true;
      this.isSigning = false;
      this.toastService.showSuccess(UPLOADED_DOCUMENT);

      this.navigateBackToDqfDocuments();
    });
  }
  loadDocuments(turnOffSkeletonLoading?: boolean): void {
    if (!turnOffSkeletonLoading) {
      this.isContentReady = false;
    }
    this.registrationService
      .loadDriver(DISABLE_TOP_LOADING_BAR)
      .pipe(map(() => this.store.selectSnapshot(RegistrationState.notification)))
      .subscribe((notificationStateModel: NotificationStateModel) => {
        if (notificationStateModel && notificationStateModel.notifications.length) {
          let filterContent = DOCUMENT_TYPE_SIGN;
          if (this.isEmploymentHistoryCheck) {
            filterContent = EMPLOYMENT_HISTORY_CHECK;
          }

          const filteredValue = notificationStateModel.notifications.filter(
            notification =>
              notification.type === filterContent && notification?.dqfId === this.driverQualificationService.dqfId
          );
          if (!turnOffSkeletonLoading) {
            this.isContentReady = true;
          }
          if (filteredValue.length) {
            // Uncomment this when we want to use canvas signature
            // this.declarationFormDriverData = filteredValue.some(
            //   notification => notification.status === UPLOADED_STATUS || notification.status === SIGNED_STATUS
            // )
            //   ? filteredValue.some(
            //       notification => notification.status === UPLOADED_STATUS || notification.status === SIGNED_STATUS
            //     )
            //   : filteredValue[0];
            // if (
            //   this.declarationFormDriverData.status === SIGNED_STATUS ||
            //   this.declarationFormDriverData.status === UPLOADED_STATUS
            // ) {
            this.declarationFormDriverData = filteredValue[0];

            if (this.declarationFormDriverData.status === SIGNED_STATUS) {
              this.isDocumentProcessing = true;
              this.isSigning = false;
            } else if (this.declarationFormDriverData.status === PENDING_STATUS.toLocaleLowerCase()) {
              this.isDocumentProcessing = false;
              this.defaultDateAndButtonText();
              if (filterContent === EMPLOYMENT_HISTORY_CHECK) {
                this.loadHelloSignData();
              }
            } else {
              this.isDocumentProcessing = false;
              this.isSigning = false;
              this.assignViewDateAndButtonText();
            }
          } else {
            this.isDocumentProcessing = false;
            this.defaultDateAndButtonText();
            // this.loadHelloSignData();
            if (filterContent === EMPLOYMENT_HISTORY_CHECK) {
              this.loadHelloSignData();
            }
          }
        } else {
          this.isDocumentProcessing = false;
          this.defaultDateAndButtonText();
          // this.loadHelloSignData();
          if (this.isEmploymentHistoryCheck) {
            this.loadHelloSignData();
          }
        }
        if (!turnOffSkeletonLoading) {
          this.isContentReady = true;
        }
      });
  }

  loadZohoSignData() {
    this.zohoSigningUrl = '';

    // For regular declarations with Zoho Sign, check cache first, then make API call if needed
    if (!this.isEmploymentHistoryCheck) {
      const cachedUrl = this.driverQualificationService.getAndConsumeHelloSignUrl(DOCUMENT_TYPE_SIGN);
      if (cachedUrl?.signatureUrl) {
        this.openZohoSignDialog();
        return;
      } else {
        // Fall through to make API call for regular declaration
      }
    }

    const declarationModel = {
      actorType: ACTOR_TYPE_DRIVER,
      documentDisplayName: this.isEmploymentHistoryCheck ? EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME : DOCUMENT_SIGN_DISPLAY_NAME,
      documentType: this.isEmploymentHistoryCheck ? EMPLOYMENT_HISTORY_CHECK : DOCUMENT_TYPE_SIGN,
      context: DRIVER_DOC_CONTEXT_INITIAL_DQF,
      dqfId: this.dqfId
    };

    this.driverQualificationService
      .getHelloSignUrl(declarationModel)
      .pipe(
        tap((response: any) => {
          if (response?.signatureUrl) {
            this.signingUrl = response.signatureUrl;
            this.documentId = response.documentId;
            this.isSigningReady = true;

            if (this.isSignRequested) {
              this.openZohoSignDialog();
            }
          }
        }),
        catchError(error => {
          this.isSigningReady = false;
          this.toastService.showError(ERROR_LOADING_RESOURCES);
          return error;
        })
      )
      .subscribe();
  }

  openZohoSignDialog(): void {
    const documentType = this.isEmploymentHistoryCheck ? EMPLOYMENT_HISTORY_CHECK : DOCUMENT_TYPE_SIGN;
    const url = this.driverQualificationService.getAndConsumeHelloSignUrl(documentType);
    if (url?.signatureUrl) {
      const signatureUrl = url.signatureUrl;

      this.zohoSigningUrl = this.sanitizer.bypassSecurityTrustResourceUrl(signatureUrl);
      this.showIframe = true;
    } else {
      this.toastService.showError('Unable to load signing interface. Please try again.');
      this.isContentReady = true;
    }
  }

  onCloseIframe(): void {
    this.resetZohoSignState();
    this.isContentReady = true;
    this.loadDocuments(true);
  }

  resetZohoSignState(): void {
    this.zohoSigningUrl = '';
    this.signingUrl = '';
    this.isSigningReady = false;
    this.showIframe = false;
    this.documentId = null;

    // Clear HelloSign cache in case it wasn't consumed
    const documentType = this.isEmploymentHistoryCheck ? EMPLOYMENT_HISTORY_CHECK : DOCUMENT_TYPE_SIGN;
    this.driverQualificationService.clearZohoSignUrlCache(documentType);
  }

  handleRoutingFromZoho = (event: MessageEvent): void => {
    // Allow messages from Zoho Sign domains and current origin
    const allowedOrigins = [
      window.location.origin,
      'https://sign.zoho.com',
      'https://sign.zoho.ca',
      'https://sign.zoho.eu',
      'https://sign.zoho.in',
      'https://sign.zoho.com.au'
    ];

    if (!allowedOrigins.includes(event.origin)) {
      return;
    }

    // Handle different types of messages from Zoho Sign
    if (event.data) {
      // Handle redirect action
      if (event.data.action === 'zoho-sign-redirect' && event.data.path) {
        const iframe = document.getElementById('iframe_callback');
        if (iframe) {
          iframe.parentNode?.removeChild(iframe);
        }

        // Store in sessionStorage
        sessionStorage.setItem('pendingZohoRedirect', event.data.path);

        if (event.data.path.includes('driverQualification/uploads?type=Driver Uploads')) {
          this.updateDocumentStatus(this.documentId, SIGNED_STATUS);
        } else if (event.data.path.includes('driverQualification/signDeclaration')) {
          this.onSignDeclined();
        }
        sessionStorage.removeItem('pendingZohoRedirect');
      }

      // Handle signing completion
      else if (event.data.type === 'SIGN_COMPLETED' || event.data.action === 'completed') {
        this.updateDocumentStatus(this.documentId, SIGNED_STATUS);
      }

      // Handle signing cancellation
      else if (event.data.type === 'SIGN_CANCELLED' || event.data.action === 'cancelled') {
        this.onSignDeclined();
      }

      // Handle errors
      else if (event.data.type === 'ERROR' || event.data.error) {
        this.toastService.showError('An error occurred during signing. Please try again.');
        this.resetZohoSignState();
        this.isContentReady = true;
      }
    }
  };

  onSignComplete(): void {
    this.toastService.showSuccess('Document signed successfully!');
    this.showIframe = false;
    this.navigateBackToDqfDocuments();
  }

  onSignDeclined(): void {
    this.toastService.showSuccess('Something went wrong please try again later!');
    this.showIframe = false;
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_SIGN_DECLARATION}`]);
  }
  determineSignatureStatus(): void {
    if (this.declarationFormDqfData.length) {
      if (this.declarationFormDqfData[0].status === REJECTED_STATUS) {
        this.isDocumentProcessing = false;
        this.isRejected = true;
      }
    }
  }
  deleteDocument(): void {
    if (confirm(DELETE_MESSAGE)) {
      if (this.declarationFormDriverData) {
        this.isContentReady = false;
        this.driverQualificationService
          .deleteDqfDocument(this.declarationFormDriverData.id, DISABLE_TOP_LOADING_BAR)
          .subscribe(() => {
            this.isContentReady = true;
            this.isSigningReady = false;
            this.loadHelloSignData();
            this.toastService.showSuccess(DELETED_DOCUMENT);
            this.isRejected = false;
            this.isDocumentProcessing = false;
            this.declarationFormDriverData = undefined;
            this.defaultDateAndButtonText();
          });
      }
    }
  }
  updateDocumentStatus(documentId: string, status: string): void {
    this.showIframe = false;
    if (documentId && status) {
      this.isContentReady = false;
      const saveModel = {
        status: status
      };
      this.driverQualificationService
        .updateDocument(documentId, saveModel, DISABLE_TOP_LOADING_BAR)
        .pipe(
          first(),
          tap(() => {
            this.toastService.showSuccess(COLLECTED_DOCUMENT);
            setTimeout(() => {
              this.setDocumentStatusDriverReviewed();
            }, 1500);
          }),
          catchError(error => {
            this.isContentReady = true;
            this.toastService.showError('Failed to update document status. Please try again.');
            // Navigate back to DQF documents page even on error to prevent white screen
            setTimeout(() => {
              this.navigateBackToDqfDocuments();
            }, 2000);
            return of(null); // Return observable to prevent error propagation
          })
        )
        .subscribe();
    } else {
      // If no documentId or status, navigate back to prevent white screen
      this.navigateBackToDqfDocuments();
    }
  }

  private navigateBackToDqfDocuments(): void {
    const dqfId = this.dqfId || this.driverQualificationService.dqfId;
    if (dqfId) {
      this.router.navigate([ROUTE_DQF, ROUTE_DQF_DOCUMENT_UPLOAD, dqfId]);
    } else {
      this.router.navigate([ROUTE_DQF]);
    }
  }

  private assignViewDateAndButtonText(): void {
    this.buttonText = 'View Declaration';
    this.declarationLabel = DEFAULT_DECLARATION_SIGNED;
    if (this.isEmploymentHistoryCheck) {
      this.buttonText = 'View';
      this.declarationLabel = EMPLOYMENT_HISTORY_CHECK_DECLARATION_SIGNED;
      // this.dontShowViewButton = true;
    }

    this.generationDate = dayjs(this.declarationFormDriverData.generationDate).format('DD-MM-YYYY');
  }
  private defaultDateAndButtonText(): void {
    this.buttonText = 'Sign Declaration';
    if (this.isEmploymentHistoryCheck) {
      this.buttonText = 'Sign';
    } else if (!this.isEmploymentHistoryCheck) {
      this.buttonText = 'Sign Declaration';
    }
    this.isSigning = true;
  }
}
